export class Logger {
    static log(_referFrom: any, _message: string) {
        console.error(`${_referFrom} :: ${_message}`);
    }
}
